/**
 * Homepage FAQ entries, in display order. Shared by the FAQ accordion (client)
 * and the page's `FAQPage` JSON-LD (server) so search engines see exactly the
 * questions the visitor sees.
 */
export const FAQ_QUESTION_KEYS = [
  "whatIsAnItem",
  "whatIsBriefPanel",
  "howDoesItWork",
  "whatCanITrack",
  "howOften",
  "howMuchDoesItCost",
  "isThereFreeTrial",
] as const;
